import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';
import { Colors } from '../../styles/colors';
import { carouselCardWidthCss } from '../car/carCarouselCardWidth';

const CardContainer = styled.div`
  ${tw`
    flex
    flex-col
    overflow-hidden
    flex-shrink-0
  `}
  background: ${Colors.White};
  border: 1px solid ${Colors.BorderLight};
  border-radius: 12px;
  ${carouselCardWidthCss}
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

const ImageSkeleton = styled(Skeleton)`
  ${tw`w-full`}
  aspect-ratio: 16 / 10;
  border-radius: 12px 12px 0 0;
`;

const ContentContainer = styled.div`
  ${tw`flex flex-col px-3 pt-2 pb-3 max-w-full min-w-0 box-border`}
  gap: 6px;
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`h-4 w-36`}
`;

const MetaSkeleton = styled(Skeleton)`
  ${tw`h-3.5 w-28`}
`;

const PriceSkeleton = styled(Skeleton)`
  ${tw`h-4 w-20 mt-1`}
`;

const CarCarouselCardSkeleton: React.FC = () => (
  <CardContainer aria-hidden>
    <ImageSkeleton />
    <ContentContainer>
      <TitleSkeleton />
      <MetaSkeleton />
      <PriceSkeleton />
    </ContentContainer>
  </CardContainer>
);

export default CarCarouselCardSkeleton;
